import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';
import SwiperBlockData from './Data';
import SwiperBlockView from './View';

const SwiperBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <SwiperBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <SwiperBlockData data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(SwiperBlockEdit);
